<template>
</template>

<script>
	//民族集合
	const nationList = [{
			"value": "01",
			"label": "汉族"
		}, {
			"value": "02",
			"label": "蒙古族"
		}, {
			"value": "03",
			"label": "回族"
		},
		{
			"value": "04",
			"label": "藏族"
		}, {
			"value": "05",
			"label": "维吾尔族"
		}, {
			"value": "06",
			"label": "苗族"
		},
		{
			"value": "07",
			"label": "彝族"
		}, {
			"value": "08",
			"label": "壮族"
		}, {
			"value": "09",
			"label": "布依族"
		},
		{
			"value": "10",
			"label": "朝鲜族"
		}, {
			"value": "11",
			"label": "满族"
		}, {
			"value": "12",
			"label": "侗族"
		},
		{
			"value": "13",
			"label": "瑶族"
		}, {
			"value": "14",
			"label": "白族"
		}, {
			"value": "15",
			"label": "土家族"
		},
		{
			"value": "16",
			"label": "哈尼族"
		}, {
			"value": "17",
			"label": "哈萨克族"
		}, {
			"value": "18",
			"label": "傣族"
		},
		{
			"value": "19",
			"label": "黎族"
		}, {
			"value": "20",
			"label": "傈僳族"
		}, {
			"value": "21",
			"label": "佤族"
		},
		{
			"value": "22",
			"label": "畲族"
		}, {
			"value": "23",
			"label": "高山族"
		}, {
			"value": "24",
			"label": "拉祜族"
		},
		{
			"value": "25",
			"label": "水族"
		}, {
			"value": "26",
			"label": "东乡族"
		}, {
			"value": "27",
			"label": "纳西族"
		},
		{
			"value": "28",
			"label": "景颇族"
		}, {
			"value": "29",
			"label": "柯尔克孜族"
		}, {
			"value": "30",
			"label": "土族"
		},
		{
			"value": "31",
			"label": "达斡尔族"
		}, {
			"value": "32",
			"label": "仫佬族"
		}, {
			"value": "33",
			"label": "羌族"
		},
		{
			"value": "34",
			"label": "布朗族"
		}, {
			"value": "35",
			"label": "撒拉族"
		}, {
			"value": "36",
			"label": "毛南族"
		},
		{
			"value": "37",
			"label": "仡佬族"
		}, {
			"value": "38",
			"label": "锡伯族"
		}, {
			"value": "39",
			"label": "阿昌族"
		},
		{
			"value": "40",
			"label": "普米族"
		}, {
			"value": "41",
			"label": "塔吉克族"
		}, {
			"value": "42",
			"label": "怒族"
		},
		{
			"value": "43",
			"label": "乌孜别克族"
		}, {
			"value": "44",
			"label": "俄罗斯族"
		}, {
			"label": "45",
			"label": "鄂温克族"
		},
		{
			"value": "46",
			"label": "崩龙族"
		}, {
			"value": "47",
			"label": "保安族"
		}, {
			"value": "48",
			"label": "裕固族"
		},
		{
			"value": "49",
			"label": "京族"
		}, {
			"label": "50",
			"label": "塔塔尔族"
		}, {
			"value": "51",
			"label": "独龙族"
		},
		{
			"value": "52",
			"label": "鄂伦春族"
		}, {
			"value": "53",
			"label": "赫哲族"
		}, {
			"value": "54",
			"label": "门巴族"
		},
		{
			"value": "55",
			"label": "珞巴族"
		}, {
			"value": "56",
			"label": "基诺族"
		}, {
			"value": "99",
			"label": "未知"
		}
	];

	//性别列表
	const sexList = [ {
			value: '1',
			label: '男'
		},
		
		{
			value: '2',
			label: '女'
		},
		{
			value: '0',
			label: '未知的性别'
		}
   		
	];
	//证件类别代码表 CV02.01.101
	const cardTypeList = [{
			value: '01',
			label: '居民身份证'
		},
		{
			value: '02',
			label: '居民户口簿'
		}, 
		{
			value: '03',
			label: '护照'
		},
		{
			value: '04',
			label: '军官证'
		},
		{
			value: '05',
			label: '驾驶证'
		},
		{
			value: '06',
			label: '港澳居民来往内地通行证'
		},
		{
			value: '07',
			label: '台湾居民来往内地通行证'
		},
		{
			value: '08',
			label: '出生医学证明'
		},
		{
			value: '99',
			label: '其他法定有效证'
		}
	];
	//婚姻状况(GB/T 2261.2-2003)
	const marriageList = [{
			value: '10',
			label: '未婚'
		},
		{
			value: '20',
			label: '已婚'
		}, 
		{
			value: '21',
			label: '初婚'
		},
		{
			value: '22',
			label: '再婚'
		},
		{
			value: '23',
			label: '复婚'
		},
		{
			value: '30',
			label: '丧偶'
		},
		{
			value: '40',
			label: '离婚'
		},
		{
			value: '90',
			label: '未说明的婚姻状况'
		}
	];
	// 职业分类代码(简要分类)(GB/T 6565-2009)
	const workCodeList = [{
			value: '0',
			label: '国家机关党群组织、企事业单位负责人'
		},
		{
			value: '1',
			label: '各类专业技术人员'
		}, 
		{
			value: '3',
			label: '办事人员和有关人员'
		},
		{
			value: '4',
			label: '商业、服务业人员'
		},
		{
			value: '5',
			label: '农、林、牧、渔、水利业生产人员'
		},
		{
			value: '6',
			label: '生产、运输设备操作人员及有关人员'
		},
		{
			value: 'X',
			label: '军人'
		},
		{
			value: 'Y',
			label: '不便分类的其他从业人员'
		}
	];
	//建卡渠道列表
	const channelList = [ {
			value: '1',
			label: '平台H5'
		},
		
		{
			value: '2',
			label: '平台小程序'
		},
		{
			value: '3',
			label: '在线问诊'
		}
   		
	];
	//政治面貌
	const outlookList = [
		{
			value: '1',
			label: '共产党员'
		},
		{
			value: '2',
			label: '民主党派'
		},
		{
			value: '3',
			label: '群众'
		},
	];
	//在职情况
	const employmentList = [
		{
			value: '1',
			label: '在职'
		},
		{
			value: '2',
			label: '退休'
		},
		{
			value: '3',
			label: '其他'
		},
	];
	// 关系
	const relationshipList =  [
		{
			value: '1',
			label: '父母'
		},
		{
			value: '2',
			label: '兄弟'
		},
		{
			value: '3',
			label: '姐妹'
		},
		{
			value: '4',
			label: '配偶'
		},
		{
			value: '5',
			label: '其他'
		}
	]
	export default {
		nationList,
		sexList,
		cardTypeList,
		marriageList,
		workCodeList,
		channelList,
		outlookList,
		employmentList,
		relationshipList
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/globelPageData.vue